<template>
   <div class="service_list">
      <div class="title h4">Active Services</div>
      <div class="row">
         <div class="col-md-6 col-lg-4 col-xl-3" v-for="(service,i) in service_lists" :key="i">
            <div class="service">
               <div class="icon"><i class="fa fa-box"></i></div>
               <div class="name">{{service.name}}</div>
               <div class="key">Active Nodes: <b>{{service.nodes.length}}</b></div>
               <div class="desc">{{service.description || 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quibusdam nobis ipsum ipsam vitae earum minus corporis dicta in a voluptas quasi molestiae eveniet, beatae excepturi alias explicabo illum quas quidem.'}}</div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import service_list from "./service_list.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('service_list')
   },
   created(){
      Event.$emit('loader:show',true)
      utils.registerModule('service_list',service_list,this.$store)
   },
   components:{
      Delete: () => import("wino-template/components/delete"),
      Modal: () => import("wino-template/components/modal"),
      Form: () => import("clarks/components/form"),
      Table: () => import("clarks/components/ivu-table"),
   },
   computed: {
      ...mapGetters([
         'Model',
         'service_lists',
         'loading',
      ])
   },
   methods: {
      ...mapActions([
         'fetchData',
         'handleActions',
      ]),
   },
   async mounted(){
      utils.registerModule('service_list',service_list,this.$store)
      await this.fetchData()
   }
}
</script>

<style lang="scss">
   .service_list{
      .title{
         margin: 10px 0 30px 0;
      }

      .service{
         border: solid 1px $border-grey;
         padding: 10px 15px;
         border-radius: 3px;
         cursor: pointer;

         &:hover{
            border-color: $primary;
         }

         .icon{
            font-size: 50px;
            margin: 0 0 10px 0;
         }
         .name{
            font-size: 16px;
            font-weight: 600;
            text-transform: uppercase;
         }

         .key{
            font-size: 13px;
            font-weight: 600;

            b{
               color: $primary;
               font-size: 15px;
            }
         }

         .desc{
            margin: 10px 0 0 0;
         }
      }
   }
</style>